import { render, staticRenderFns } from "./selectOrderFrozenModel.vue?vue&type=template&id=d90b262c&scoped=true&"
import script from "./selectOrderFrozenModel.vue?vue&type=script&lang=js&"
export * from "./selectOrderFrozenModel.vue?vue&type=script&lang=js&"
import style0 from "./selectOrderFrozenModel.vue?vue&type=style&index=0&id=d90b262c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d90b262c",
  null
  
)

export default component.exports